const data_CN = {
  topPage: {
    rightImg:require("@/assets/contactUs/photo1.png"),
    name:'联系我们',
    introText:'OFFSHORE将通过制作业务、制作业务和广告营销业务充当所有人的桥梁，并将监督从人力资源开发到内容货币化的一切，为创作者、粉丝和客户做出贡献，并带来利润。',
  },
  company: {
    title: '公司信息',
    list: [
      {name: '联系电话', info: '07031444410'},
      {name: '电子邮箱', info: 'b.liao@rss90.com'},
      {name: '总公司', info: ['T 173-0004', '东京都板桥区板桥1丁目40号8号第2板桥迈科波403号室']},
      // {name: '东京办事处', info: ['干550-0014', '大限府大阪市西区北掘江1-2-17', '四少播川崎芒儿 8F']}
    ]
  },
  creatorProcess: {
    title: '创作者注册流程',
    icon: require("@/assets/contactUs/creatorProcess/icon_star@2x.png"),
    list: [
      {
        step: 'STEP1',
        name: '注册官方LINE',
        info: '请通过画面下方的按钮注册官方LINE，并根据从官方LINE收到的消息发送必要的物品。',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step1@2x.png")
      },
      {
        step: 'STEP2',
        name: '听力',
        info: '我们将与我们的员工讨论我们的规则、细节以及您可能有的任何问题。',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step2@2x.png")
      },
      {
        step: 'STEP3',
        name: '联系我们',
        info: '我们会在面试后的几天内与您联系。 如果彼此没有问题，我们将与我们公司签订创作者合同。',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step3@2x.png")
      },
      {
        step: 'STEP4',
        name: '活动开始',
        info: '目前为止就这样了。 让我们在接受我们的管理的同时努力成为有影响力的人！',
        img: require("@/assets/contactUs/creatorProcess/setup_step05@2x.png")
      }
    ]
  },
  establishmentProcess: {
    title: '主播申请流程',
    list: [
      {
        step: 'STEP1',
        name: '询问',
        info: '首先，请通过屏幕底部的按钮注册官方LINE并联系我们。',
        img: require("@/assets/contactUs/establishmentProcess/pic_logon_step1@2x.png")
      },
      {
        step: 'STEP2',
        name: '文件审查',
        info: '请填写筛选表，只有通过筛选的人才会被联系。',
        img: require("@/assets/contactUs/establishmentProcess/setup_step02@2x.png")
      },
      {
        step: 'STEP3',
        name: '会议',
        info: '负责人将与您联系并安排线上会议',
        img: require("@/assets/contactUs/establishmentProcess/setup_step03@2x.png")
      },
      {
        step: 'STEP4',
        name: '代理注册',
        info: '作为会议的结果，我们将要求那些我们认为合适的人注册成为代理人。',
        img: require("@/assets/contactUs/establishmentProcess/setup_step04@2x.png")
      },
      {
        step: 'STEP5',
        name: '活动开始',
        info: '目前为止就这样了。 吸引现场直播并增加您的销售额。我们将支持您在运营过程中吸引客户。',
        img: require("@/assets/contactUs/establishmentProcess/setup_step05@2x.png")
      }
    ]
  },
  contact: {
    title: '联系方式',
    desc: ['请从以下注册官方LINE并联系我们。', '我们全天 24 小时提供咨询和申请服务。'],
    contactIcon: {
      line: require("@/assets/contactUs/contactInfo/icon_line@2x.png"),
      weChat: require("@/assets/contactUs/contactInfo/icon_wechat@2x.png"),
      arrow: require("@/assets/contactUs/contactInfo/icon_go@2x.png"),
      back: require("@/assets/contactUs/contactInfo/joinus@2x.png")
    }
  },
  questionAndAnswer: {
    title: '常见问题',
    cityOption: ['创作者问答', '代理问答'],
    createQuestion :
    [
      {
        question:'我没有用过 TikTok 或 LIVE 分发应用程序来发帖的经验。这种情况可以报名吗？',
        answer:'是的，没关系。\n您可以仍然为我们管理下的影响者。'
      },
      {
        question:'成为会员需要任何费用吗？',
        answer:'不，它不需要任何费用。\n即使您退出，也没有罚款等不利条件，因此请随时申请。'
      },
      {
        question:'需要有配额吗？',
        answer:'不，没有配额。\n请放心，即使您签约了，您也不会被迫张贴或分发。'
      },
      {
        question:'男性也可以申请吗？',
        answer:'当然可以'
      },
      {
        question:'有什么申请条件吗？',
        answer:'任何年龄在18 至 35 岁之间的人都可以申请。'
      },
      {
        question:'我属于娱乐公司，我还能申请吗？',
        answer:'可以的。但是需要在获得您所属办公室的许可后进行。'
      },
      {
        question:'可以咨询或提问吗？',
        answer:'我们只接受咨询和提问。\n请随时与我们联系。'
      },
      {
        question:'作为副业，是否可以兼职？',
        answer:'它可以用作主要工作或副业。\n请随时申请。'
      }
    ],
    proxyQuestion :
    [
      {
        question:'合同中有条件吗？',
        answer:'不。对个人或公司没有任何条件。\n但是，询价后，我们会在审核表格和讨论会议后审核相关文件。'
      },
      {
        question:'能赚到钱吗？',
        answer:'是的，我们会尽力支持你。\n我们实现了行业最高水平的回报，因此有很多创作者独立或从其他公司跳槽。'
      },
      {
        question:'设置费用是多少？',
        answer:'不。可以用0日元成立。\n其他公司通常需要初始成本和合同费，但我们不收取任何费用，因此可以以0日元成立和开展业务。\n并且我们会为您提供我们使用的模板，例如您希望我们准备的与附属创作者的合同。\n* 如果请律师制作，费用会很高。\n因此，可以设置为0日元。'
      },
      {
        question:'怎样才能获得高额回报？',
        answer:'在代理机构的合作下，我们工作室培养了很多优质的创作者，所以我们即使只收取少量的版税，也能实现盈利和运营。\n此外，只有最低限度的运营所需员工常驻，有效地抑制了人员费用等成本，实现了利润最大化，因此我们成功地提高了对代理商的报酬。'
      },
      {
        question:'我担心吸引客户，\n你能告诉我如何吸引客户吗？',
        answer:'是的，我们会教给您我们办公室的诀窍，这样您就可以毫无问题地吸引客户。\n即使是从未尝试过吸引客户的代理商，现在也在不断增加创作者的数量。\n我们将支持所有其他问题，因此请随时与我们联系。'
      },
      {
        question:'我很担心我是否可以管理它，\n你能告诉我吗？',
        answer:'是的，我们会教给您我们的专业知识，这样您就可以毫无问题地进行管理。\n即使是没有管理经验的机构现在也在培养有影响力的人。\n我们将支持所有其他问题，因此请随时与我们联系。'
      },
      {
        question:'我对办公室管理一无所知。\n你同意吗？',
        answer:'是的，没关系。我们将从头开始咨询和支持操作方法，因此即使您没有经验也请随时申请。'
      },
      {
        question:'我已经是一个签约主播了，可以接手 TikTok LIVE吗？',
        answer:'是的，没关系。\n我们不接受TikTok LIVE的申请，但其他申请没有问题，请放心申请。'
      },
      {
        question:'我已经有一份固定的工作了，还可以发展这个业务吗？',
        answer:'我可以。您可以期望收入增加，因为您将获得个人和办公室的双倍报酬。'
      }
    ]
  }
}

const data_JA = {
  topPage: {
    rightImg:require("@/assets/contactUs/photo1.png"),
    name:'お問い合わせ',
    introText:'OFFSHOREは、制作事業、制作事業、広告マーケティング事業を通じて皆様の架け橋となり、人材育成からコンテンツのマネタイズまでをトータルに統括し、クリエイター、ファン、お客様に貢献し、利益をもたらしてまいります。',
  },
  company: {
    title: '企業情報',
    list: [
      {name: '連絡先番号', info: '07031444410'},
      {name: 'Eメール', info: 'b.liao@rss90.com'},
      {name: '本社', info: ['T 173-0004', '東京都板橋区板橋１丁目40番8号第2板橋マイコーポ403号室']},
      // {name: '東京事務所', info: ['干550-0014', '大限府大阪市西区北掘江1-2-17', '四少播川崎芒儿 8F']}
    ]
  },
  creatorProcess: {
    title: 'クリエイター登録の流れ',
    icon: require("@/assets/contactUs/creatorProcess/icon_star@2x.png"),
    list: [
      {
        step: 'STEP1',
        name: '公式LINEを登録する',
        info: '画面下のボタンから公式LINEに連絡し、公式LINEから受信したメッセージに基づいて必要な資料を送信してください。',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step1@2x.png")
      },
      {
        step: 'STEP2',
        name: 'コミュニケーション',
        info: '運営に関するルール、詳細、およびお客様が抱える可能性のある問題についてお話しします。',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step2@2x.png")
      },
      {
        step: 'STEP3',
        name: 'お問い合わせ',
        info: '“面談後数日以内にご連絡いたします。お互いに協力する意思があれば、私たちはあなたとクリエイター契約を締結します。”',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step3@2x.png")
      },
      {
        step: 'STEP4',
        name: '活動が始まります',
        info: '一緒に私たちのチームに参加して、チーム管理の運営を通じて、あなたを急速に影響力のある人になります！',
        img: require("@/assets/contactUs/creatorProcess/setup_step05@2x.png")
      }
    ]
  },
  establishmentProcess: {
    title: '設立までの流れ',
    list: [
      {
        step: 'STEP1',
        name: 'コンサルティング',
        info: 'まず、画面下部のボタンから公式LINEを登録して連絡してください。',
        img: require("@/assets/contactUs/establishmentProcess/pic_logon_step1@2x.png")
      },
      {
        step: 'STEP2',
        name: '資料の確認',
        info: '申込書に記入して、書類審査が通過したら、連絡します。',
        img: require("@/assets/contactUs/establishmentProcess/setup_step02@2x.png")
      },
      {
        step: 'STEP3',
        name: 'コミュニケーション',
        info: '担当者があなたに連絡し、ライン会議を設置します\\',
        img: require("@/assets/contactUs/establishmentProcess/setup_step03@2x.png")
      },
      {
        step: 'STEP4',
        name: 'エージェント登録',
        info: '双方のコミュニケーションの結果、適切な人を代理人として登録するように招待します。',
        img: require("@/assets/contactUs/establishmentProcess/setup_step04@2x.png")
      },
      {
        step: 'STEP5',
        name: '活動が始まりました。',
        info: 'あらゆる種類のライブ配信者を募集して、ライブ配信者の売上を増やします。 運用プロセスにおけるあらゆる問題の解決をお手伝いします。',
        img: require("@/assets/contactUs/establishmentProcess/setup_step05@2x.png")
      }
    ]
  },
  contact: {
    title: '連絡先',
    desc: ['以下の公式LINEアカウントから登録し、お問い合わせください。', '24時間、相談や申請に対応いたします。'],
    contactIcon: {
      line: require("@/assets/contactUs/contactInfo/icon_line@2x.png"),
      weChat: require("@/assets/contactUs/contactInfo/icon_wechat@2x.png"),
      arrow: require("@/assets/contactUs/contactInfo/icon_go@2x.png"),
      back: require("@/assets/contactUs/contactInfo/joinus@2x.png")
    }
  },
  questionAndAnswer: {
    title: 'よくある質問',
    cityOption: ['クリエイターQ＆A', 'エージェントのQ&A'],
    createQuestion :
    [
      {
        question:'TikTokやLIVE配信アプリを使用して投稿した経験がありません。申請可能ですか？ TikTok 或 LIVE 分发应用程序来发帖的经验。这种情况可以报名吗？',
        answer:'はい、大丈夫です。\nあなたはすぐに私たちのチームの影響力を持つ人になることができます'
      },
      {
        question:'メンバーになるためには、何らかの費用が必要ですか？',
        answer:'いいえ、何の費用も必要ありません。\nもし参加を中止されても、罰金などの不利な条件はございませんので、お気軽にお申し込みください。'
      },
      {
        question:'ノルマはありますか？',
        answer:'いいえ、ノルマはありません。\n所属しても投稿や配信を強制することはありませんので、ご安心ください。'
      },
      {
        question:'男性でも応募できますか？',
        answer:'はい、できます。'
      },
      {
        question:'応募の条件はありますか？',
        answer:'18歳〜35歳の方はどなたでも応募可能です。'
      },
      {
        question:'芸能事務所に所属していますが、応募可能ですか？',
        answer:'可能です。但し所属されている事務所の許可をいただいてからになります。'
      },
      {
        question:'相談や質問だけでも可能ですか？',
        answer:'相談・質問だけでも受け付けております。\nお気軽にお問い合わせください。'
      },
      {
        question:'副業として、仕事と掛け持ちは可能ですか？',
        answer:'本業でも、副業としても大丈夫です。\n気軽にご応募ください。'
      }
    ],
    proxyQuestion :
    [
      {
        question:'契約には条件がありますか？',
        answer:'いいえ。個人の方でも法人の方でも条件はございません。\nただしお問い合わせ後、審査フォームでの書類審査と打ち合わせ後に審査をさせていただきます。'
      },
      {
        question:'稼げますか？',
        answer:'はい、稼いでいただくために最大限サポートいたします。\n業界最高水準の高還元を実現していますので、クリエイターとして独立される方や、他社から乗り換えされる方も多数いらっしゃいます。'
      },
      {
        question:'設立に費用はかかりますか？',
        answer:'いいえ。0円で設立可能です。\n他社様では、初期費用・契約料など必要となる場合が多いですが、弊社では一切頂いておりませんので0円設立及びスタートが可能となります。\n最低限、ご準備頂きたい所属クリエイターとの契約書などは弊社が使用しているものをテンプレートでお渡しします。\n※弁護士に作成依頼されるとかなり高額になります。\nよって、0円での設立が可能となります。'
      },
      {
        question:'どうして高還元できるのですか？',
        answer:'当事務所は代理店様のご協力のもと、ハイクオリティなクリエイターを多数輩出しておりますので、少ないロイヤリティでも利益化・運営ができております。\nまた、運営上必要最低限のスタッフのみ常駐し、効率良く人件費などのコストを抑え、利益を最大化しているため、その分代理店様への報酬を高めることに成功しております。'
      },
      {
        question:'集客に不安があるのですが、\n集客について教えてもらえますか？',
        answer:'はい、当事務所のノウハウを教えますので、問題なく集客ができるようになります。\n集客をやったことがなかった代理店様も、現在継続的にクリエイターを増やしております。\nそれ以外のお悩みも全てサポートしていきますので、なんでもお気軽にご相談ください。'
      },
      {
        question:'マネジメントしていけるか不安があるのですが、\n教えてもらえますか？',
        answer:'はい、当事務所のノウハウを教えますので、問題なくマネジメントできるようになります。\nマネジメントをやったことがなかった代理店様も、インフルエンサーを輩出するようになりました。\nそれ以外のお悩みも全てサポートしていきますので、なんでもお気軽にご相談ください。'
      },
      {
        question:'事務所運営について何もわかりません。\nそれでも大丈夫ですか？',
        answer:'はい、大丈夫です。いちから運営方法をコンサル・サポートしていきますので、経験がなくてもお気軽にご応募ください。'
      },
      {
        question:'ライバー事務所をしていてTikTok LIVEを扱いたいのですが、掛け持ちで契約はできますか？',
        answer:'はい、大丈夫です。\nTikTok LIVEの掛け持ちはお受けできませんが、その他アプリの掛け持ちは問題ありませんので、お気軽にご応募ください。'
      },
      {
        question:'設立した事務所で自分自身も配信できますか？',
        answer:'はい、できます。個人と事務所のダブルで報酬が入りますので、収入アップも見込めます。'
      }
    ]
  }
}
 
const data_EN = {
  topPage: {
    rightImg:require("@/assets/contactUs/photo1.png"),
    name:'Contact us',
    introText:'OFFSHORE will act as a bridge for everyone through the production business, production business, and advertising marketing business, and will oversee everything from human resource development to content monetization, contributing to creators, fans, and customers, and bringing in profits.',
  },
  company: {
    title: 'Company information',
    list: [
      {name: 'Contact number', info: '07031444410'},
      {name: 'E-mail', info: 'b.liao@rss90.com'},
      {name: 'Head office', info: ['T 173-0004', 'Room 403, 2nd Itabashi MyCoop, 8-40-1 Itabashi 1-chome,', 'Itabashi-ku, Tokyo, Japan.']},
      // {name: 'Tokyo Office', info: ['干550-0014', '大限府大阪市西区北掘江1-2-17', '四少播川崎芒儿 8F']}
    ]
  },
  creatorProcess: {
    title: 'Creator Registration Process',
    icon: require("@/assets/contactUs/creatorProcess/icon_star@2x.png"),
    list: [
      {
        step: 'STEP1',
        name: 'Register official LINE',
        info: 'Please register on the official LINE with the button at the bottom of the screen, and send necessary items according to the message received from the official LINE.',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step1@2x.png")
      },
      {
        step: 'STEP2',
        name: 'Hearing',
        info: 'We will discuss our rules, details and any questions you may have with our staff.',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step2@2x.png")
      },
      {
        step: 'STEP3',
        name: 'Contact us',
        info: 'We will contact you within a few days of the interview.\nIf there are no problems with each other, we will conclude a creator contract with our company. ',
        img: require("@/assets/contactUs/creatorProcess/pic_logon_step3@2x.png")
      },
      {
        step: 'STEP4',
        name: 'Activity starts',
        info: "That's all for now.\nLet's try to be influential while accepting our management! ",
        img: require("@/assets/contactUs/creatorProcess/setup_step05@2x.png")
      }
    ]
  },
  establishmentProcess: {
    title: 'Process before establishment',
    list: [
      {
        step: 'STEP1',
        name: 'Ask',
        info: 'First, please register the official LINE and contact us through the button at the bottom of the screen.',
        img: require("@/assets/contactUs/establishmentProcess/pic_logon_step1@2x.png")
      },
      {
        step: 'STEP2',
        name: 'Document review',
        info: 'Please fill out the screening form,\nOnly those who pass the screening will be contacted. ',
        img: require("@/assets/contactUs/establishmentProcess/setup_step02@2x.png")
      },
      {
        step: 'STEP3',
        name: 'Meeting',
        info: 'A person in charge will contact you to arrange an online meeting',
        img: require("@/assets/contactUs/establishmentProcess/setup_step03@2x.png")
      },
      {
        step: 'STEP4',
        name: 'Agent Registration',
        info: 'As a result of the meeting, we will ask those we deem appropriate to register as agents.',
        img: require("@/assets/contactUs/establishmentProcess/setup_step04@2x.png")
      },
      {
        step: 'STEP5',
        name: 'The event has started',
        info: 'So far, that’s all for now.\nAttract live audience and increase your sales. We will support you in attracting customers during the operational process.',
        img: require("@/assets/contactUs/establishmentProcess/setup_step05@2x.png")
      }
    ]
  },
  contact: {
    title: 'Contact Information',
    desc: ['Please register the official LINE account below and contact us.', 'We provide consultation and application services 24/7'],
    contactIcon: {
      line: require("@/assets/contactUs/contactInfo/icon_line@2x.png"),
      weChat: require("@/assets/contactUs/contactInfo/icon_wechat@2x.png"),
      arrow: require("@/assets/contactUs/contactInfo/icon_go@2x.png"),
      back: require("@/assets/contactUs/contactInfo/joinus@2x.png")
    }
  },
  questionAndAnswer: {
    title: 'FAQ',
    cityOption: ['Creator Q&A', 'Proxy Q&A'],
    createQuestion :
    [
      {
        question:'I have no experience posting using TikTok or LIVE distribution applications. Can I still apply?',
        answer:'Yes, it’s okay. You can still be an influencer managed under us.'
      },
      {
        question:'Is there any cost to become a member?',
        answer:'No, it doesn’t require any cost.\nEven if you withdraw, there are no penalties or disadvantageous conditions, so please feel free to apply anytime.'
      },
      {
        question:'Is there a quota for participation?',
        answer:'No, there is no quota.\nEven if you join, there is no obligation to post or distribute, so please rest assured.'
      },
      {
        question:'Can men apply as well?',
        answer:'Yes, they can.'
      },
      {
        question:'Are there any requirements to apply?',
        answer:'Anyone between the ages of 18 and 35 can apply.'
      },
      {
        question:'I belong to an entertainment agency. Can I still apply?',
        answer:'It is possible, but you will need to get permission from your entertainment agency first.'
      },
      {
        question:'Is it possible to ask for advice or ask questions without applying for something specific?',
        answer:'We also accept inquiries and questions. Please feel free to contact us anytime.'
      },
      {
        question:'Is it possible to have a side job while working another job?',
        answer:'It’s okay to apply for both full-time and side jobs. Please feel free to apply.'
      }
    ],
    proxyQuestion :
    [
      {
        question:'Are there any conditions in the contract?',
        answer:'There are no restrictions or requirements for individuals or legal entities. However, after your inquiry, we will review the application forms and documents submitted by you, and conduct a meeting or negotiation with you before granting approval.'
      },
      {
        question:'Can I earn money?',
        answer:"Sure, we will support you to the fullest extent possible to help you earn money. We offer the industry's highest payout rates, which is why many independent creators and those who have switched from other companies have joined us."
      },
      {
        question:'How much does it cost to set up?',
        answer:"No. It is possible to set up with 0 yen.\nOther companies often require initial costs and contract fees, but we do not charge any fees, so it is possible to establish and start a business for 0 yen.\nAt a minimum, we will provide you with a template of what we use, such as contracts with affiliated creators that you would like us to prepare.\n* If you ask a lawyer to create it, it will be quite expensive.\nTherefore, it is possible to set up with 0 yen. "
      },
      {
        question:'How can I get a high return?',
        answer:"With the cooperation of our agency,\nWe have produced a large number of high-quality creators, so we are able to profit and operate even with a small amount of royalties.\nIn addition, only the minimum number of staff necessary for operation is permanently stationed, efficiently suppressing costs such as personnel expenses, and maximizing profits.\nAs a result, we have succeeded in increasing the remuneration for agents. "
      },
      {
        question:"I'm worried about attracting customers,Can you tell me about attracting customers?",
        answer:'Yes, we will teach you our know-how, so you will be able to attract customers without any problems.\nEven agencies that have never tried to attract customers are now continuously increasing the number of creators.\nWe will support all other concerns, so please feel free to contact us. '
      },
      {
        question:'Can you manage I have some concerns,\nCan you teach me? ',
        answer:'Yes, we will teach you our know-how, so you will be able to manage without problems.\nEven agencies that had no management experience are now producing influencers.\nWe will support all other concerns, so please feel free to contact us. '
      },
      {
        question:"I don't know anything about running an office.\nAre you okay with that? ",
        answer:'Yes, it is okay. We will consult and support the operation method from scratch, so please feel free to apply even if you do not have experience.'
      },
      {
        question:"I have a live agency and would like to handle TikTok LIVE.\nIs it possible to sign a contract as a part-time worker? ",
        answer:'Yes, it is okay.\nWe do not accept applications for TikTok LIVE, but there is no problem for other applications, so please feel free to apply. '
      },
      {
        question:'At the established office \nCan I distribute myself? ',
        answer:'Yes, I can. You can expect an increase in income because you will receive double compensation for individuals and offices.'
      }
    ]
  }
}

export default {
  data_CN,
  data_JA,
  data_EN
}


// WEBPACK FOOTER //
// ./src/common/json/contactUs.js